import React, { useEffect, useRef, useState } from "react";

import { Content, Card } from "./styles";
import { Container } from "../../../styles/GlobalStyles";

import Header from "../../../components/Header";
import Modal from "../../../components/Modal";
import { getToken, getUsuario, setUsuario } from "../../../services/security";
import {
  isStrongPassword,
  mascaraCelular,
  mascaraCnpj,
} from "../../../services/utils";
import Input from "../../../components/Input";
import { api } from "../../../services/api";
import Alerts from "../../../components/Alerts";
import { set } from "date-fns";
import InputPassword from "../../../components/InputPassword";
import { useHistory } from "react-router";

function AceitarTermo() {
  const history = useHistory();

  const [mensagem, setMensagem] = useState(undefined);

  const handleAceite = async () => {
    try {
      const token = getToken();
      const empresa = getUsuario();

      if (!empresa)
        return setMensagem({
          show: true,
          titulo: "Erro",
          detalhe: "Você precisa fazer login",
        });

      await api.post("/empresas/aceite-termo");

      empresa.aceitou_termos = 1;

      setUsuario(empresa);

      history.push("/empresa/home");
    } catch (e) {
      if (e.response) {
        return setMensagem({
          show: true,
          titulo: "Erro",
          detalhe: e.response.data.erro,
        });
      }
      alert(e);
    }
  };

  return (
    <Container>
      <Alerts
        mensagem={mensagem}
        setMensagem={setMensagem}
        tipo={mensagem?.tipo}
      />

      <Content>
        <h1>Aceitar Termo</h1>
        <Card>
          <iframe src="/termo-uso-empresa.html"></iframe>
          <button onClick={handleAceite}>Aceitar Termos</button>
        </Card>
      </Content>
    </Container>
  );
}

export default AceitarTermo;
